import React from 'react';
import { TablePagination as NativeTablePagination } from '@mui/material';
import { usePagination } from 'providers/pagination';
import { makeStyles } from '@mui/styles';

type PaginationProps = {
  count: number;
};

const useStyles = makeStyles({
  selectRoot: {
    marginRight: 10,
  },
  toolbar: {
    paddingLeft: '0!important',
  },
  actions: {
    marginLeft: 0,
  },
  root: {
    borderBottom: '0!important',
  },
});

const Pagination: React.FC<PaginationProps> = ({ count }) => {
  const { rowsPerPage, page, handleSetPage, handleSetRowsPerPage, rowsPerPageOption } = usePagination();
  const classes = useStyles();

  return (
    <NativeTablePagination
      classes={{
        selectRoot: classes.selectRoot,
        toolbar: classes.toolbar,
        actions: classes.actions,
        root: classes.root,
      }}
      component="div"
      labelRowsPerPage="Registros"
      rowsPerPageOptions={rowsPerPageOption}
      count={count}
      rowsPerPage={rowsPerPage}
      page={page}
      backIconButtonProps={{
        'aria-label': 'Página anterior',
      }}
      nextIconButtonProps={{
        'aria-label': 'Próxima Página',
      }}
      onPageChange={(e, page) => handleSetPage(page)}
      onRowsPerPageChange={e => handleSetRowsPerPage(parseFloat(e.target.value))}
    />
  );
};

export default Pagination;
